import { useState, useEffect } from "react";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Dialog,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import PropTypes from "prop-types";
import { DialogHeader } from "../components/DialogHeader";
import { CustomerInfoDialog } from "../components/CustomerInfoDialog";
import { PaymentBox } from "../components/PaymentBox";
import { getDefaultDateTime, validateEmail } from "../Utils/utils";
import {
  getCustomerByPhoneNo,
  registerClient,
  updateClient,
  getDeliveryCharge,
} from "../apis/RangerOnlineApi";
import { AlertPopUp } from "../components/AlertPopUp";

const steps = ["Contact Info", "Payment"];

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    boxShadow: "0px 3px 0px 1px #972020",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, name, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {name}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
};

const getDefaultDate = (date) => {
  const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  return newDate;
};

const getDefaultInfo = (minutes = 0) => {
  return {
    id: 0,
    clientId: 0,
    // orderType: "PICKUP",
    suitNo: "",
    buzzerNo: "",
    roomNo: "",
    firstName: "",
    lastName: "",
    phoneNo: "",
    email: "",
    address: "",
    orderDesc: "",
    date: getDefaultDateTime(minutes),
    time: getDefaultDateTime(minutes),
  };
};

export const CheckOutInfoDialog = (props) => {
  const {
    open,
    onClose,
    onOrderSelection,
    companyName,
    pickUpTime,
    deliveryTime,
    order,
    onTipChange,
    saveCustomerData,
    orderType,
    handleDeliveryCharge,
    taxes,
    settings,
    deliveryCharge,
    companyData,
  } = props;
  const [activeStep, setActiveStep] = useState(0);
  const [customerData, setCustomerData] = useState(
    getDefaultInfo(pickUpTime + 5)
  );
  const [value, setValue] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showClock, setShowClock] = useState(false);
  const { OnlineDeliveryBoundry } = settings;

  const handleShowClock = (show) => {
    setShowClock(show);
  };

  const handleAlert = (show, message) => {
    setShowAlert(show);
    setAlertMessage(message);
  };

  const handleTextChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;
    let letters = /^[a-zA-Z ]*$/;
    if (value.match(letters)) {
      let data = { ...customerData };
      data[id] = value;
      setCustomerData(data);
    }
  };

  const handleEmailChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;
    let data = { ...customerData };
    data[id] = value;
    setCustomerData(data);
  };

  const handlePhoneChange = (e) => {
    const re = /^[0-9\b]+$/;
    const value = e.target.value;
    let data = { ...customerData };
    if (value === "" || (re.test(value) && value.length <= 10)) {
      data.phoneNo = value;
      setCustomerData(data);
    }
  };

  const handleDateChange = (newValue) => {
    const data = { ...customerData };

    data.date = newValue;

    setCustomerData(data);
  };

  const handleTimeChange = (newValue) => {
    const data = { ...customerData };

    data.time = newValue;
    setCustomerData(data);
    setShowClock(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNumberChange = (e) => {
    const re = /^[0-9\b]+$/;
    const id = e.target.id;
    const value = e.target.value;
    let data = { ...customerData };
    if (value === "" || re.test(value)) {
      data[id] = value;
      setCustomerData(data);
    }
  };

  const handleAddressChange = (event, newAddress) => {
    let data = { ...customerData };

    data.address = newAddress;
    settings.ApplyDeliveryChargesAsKm == 1
      ? newAddress?.description &&
        getDeliveryCharge(newAddress?.description).then((x) => {
          handleDeliveryCharge(x.charges);
          if (x.distance > OnlineDeliveryBoundry) {
            handleAlert(
              true,
              "Delivery order not available on your location. Please choose another location or choose pickup.."
            );
          }
        })
      : handleDeliveryCharge(deliveryCharge);
    setCustomerData(data);
  };

  const handleNext = async () => {
    let client = {};
    let clientId = 0;

    if (customerData.phoneNo.length < 10) {
      handleAlert(true, "Error the phone number is invalid.");
      return;
    }

    if (customerData.firstName === "") {
      handleAlert(true, "Please enter your first name.");
      return;
    }

    if (customerData.email != "" && !validateEmail(customerData.email)) {
      handleAlert(true, "Please enter a valid mail.");
      return;
    }

    if (
      getDefaultDate(customerData.date) < getDefaultDate(getDefaultDateTime(0))
    ) {
      handleAlert(true, "Please select a valid date.");
      return;
    }
    if (customerData.time < getDefaultDateTime(pickUpTime)) {
      handleAlert(true, "Please select a valid hour.");
      return;
    }

    if (value == 0) {
      customerData.orderType = "TakeOut";
    } else {
      customerData.orderType = "Delivery";
      if (customerData.address?.description === "") {
        handleAlert(true, "Please select a valid address.");
        return;
      }
    }

    customerData.orderDesc = customerData.orderDesc + customerData.firstName;

    await getCustomerByPhoneNo(customerData.phoneNo).then((x) => {
      if (x?.status && x?.status === 500) {
        handleAlert(
          true,
          "There was a communication please contact the support team."
        );
      }
      client = x;
    });

    if (client?.clientId > 0) {
      clientId = client.clientId;
      customerData.clientId = clientId;
      await updateClient(orderType == "Delivery" ? "delivery" : "pickup", {
        ...customerData,
        address: customerData.address.description,
      });
    } else {
      client = await registerClient({
        ...customerData,
        address: customerData.address.description,
      });
      clientId = client.clientId;
      customerData.clientId = clientId;
    }
    saveCustomerData(customerData);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const getPaymentProvider = () => {
    if (settings.GlobalDelivery == 1 || settings.GlobalPickup == 1) {
      return "global";
    } else if (settings.MonerisDelivery == 1 || settings.MonerisPickup == 1) {
      return "moneris";
    } else if (settings.StripeDelivery == 1 || settings.StripePickup == 1) {
      return "stripe";
    } else if (settings.CloverPickup == 1 || settings.CloverDelivery == 1) {
      return "clover";
    } else if (settings.PaypalDelivery == 1 || settings.PaypalDelivery == 1) {
      return "paypal";
    }
  };

  useEffect(() => {
    orderType && setValue(orderType === "Delivery" ? 1 : 0);
  }, [orderType]);

  return (
    <BootstrapDialog
      keepMounted={false}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogHeader title={"Checkout"} subTitle={""} />
      <DialogContent dividers>
        <Box sx={{ width: "100%" }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === 0 ? (
            <CustomerInfoDialog
              tabNumber={value}
              onChangeNumber={handleChange}
              onOrderSelection={onOrderSelection}
              companyName={companyName}
              pickUpTime={pickUpTime}
              deliveryTime={deliveryTime}
              customerData={customerData}
              onTextChange={handleTextChange}
              onEMailChange={handleEmailChange}
              onPhoneChange={handlePhoneChange}
              onNumberChange={handleNumberChange}
              onDateChange={handleDateChange}
              onTimeChange={handleTimeChange}
              onAlert={handleAlert}
              onAddressChange={handleAddressChange}
              onShowClock={handleShowClock}
              showClock={showClock}
              orderType={orderType}
              typesettings={settings}
            />
          ) : (
            <PaymentBox
              paymentProvider={getPaymentProvider()}
              settings={settings}
              order={order}
              onTipChange={onTipChange}
              taxes={taxes}
              orderType={orderType}
              companyData={companyData}
            />
          )}
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
          </Box>
        </Box>
        {showAlert ? (
          <AlertPopUp
            show={showAlert}
            message={alertMessage}
            onClose={() => handleAlert(false, "")}
            closeOnTimer={false}
          />
        ) : null}
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button variant="contained" autoFocus onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={handleNext}
          sx={{
            display: activeStep === steps.length - 1 ? "none" : "block",
          }}
        >
          Next
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};
